const CACHE_KEY = "login-banner-catalog-images";
const CACHE_VERSION = 1;

export function readLoginBannerCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (parsed?.v !== CACHE_VERSION || !Array.isArray(parsed?.images)) {
      return null;
    }

    return parsed.images.some(Boolean) ? parsed.images : null;
  } catch {
    return null;
  }
}

export function writeLoginBannerCache(images) {
  try {
    if (!Array.isArray(images) || !images.some(Boolean)) return;

    localStorage.setItem(
      CACHE_KEY,
      JSON.stringify({
        v: CACHE_VERSION,
        images,
        updatedAt: Date.now(),
      }),
    );
  } catch {
    // Ignore quota / private-mode errors.
  }
}
